import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { HttpErrorResponse } from '@angular/common/http';
import { Subject } from 'rxjs/internal/Subject';

const headers = new HttpHeaders()
            .set('Content-Type', 'application/json');
@Injectable()
export class LoginService {

  baseUrl: 'api/token/generate-token';

  subject = new Subject(); 

  constructor(private http: HttpClient) {
  }

  /*attemptAuth(ussername: string, password: string): Observable<any> {
    const credentials = {username: ussername, password: password};
    console.log('attempAuth ::');
    return this.http.post(this.baseUrl, credentials);
  }*/

  public getToken(): string {
    return sessionStorage.getItem('token');
  }

  public getUserDemo(): string {
    return sessionStorage.getItem('username');
  }

  login(username: string, password: string) {
    return this.http.post<any>('/api/token/generate-token', JSON.stringify({ username: username, password: password }), { headers })
        .map(user => {        
            // login successful if there's a jwt token in the response
            if (user && user.credentials) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                let roles = user.authorities.map(item => item.authority);
                sessionStorage.setItem('token', user.credentials);
                sessionStorage.setItem('userId', user.userId);
                sessionStorage.setItem('username', user.name);
                //sessionStorage.setItem('roles', roles); 
                sessionStorage.setItem('currentUser', JSON.stringify(user));              
                this.subject.next(roles);

                // console.log("from login" + roles)
              }
           
       
            return user;
        })
        .catch((error: any) => {
          console.log(' ----error ---',error);
         
  
          return Observable.throw(error.statusText);
      });
  ;
}

logout() {
    // remove user from local storage to log user out
    //sessionStorage.removeItem('userId');
    //sessionStorage.removeItem('token');
    //sessionStorage.removeItem('currentUser');
    // location.reload();

    //window.location.reload()

    sessionStorage.setItem('userId','');
    sessionStorage.setItem('token', '');
    sessionStorage.setItem('currentUser', '');
    //sessionStorage.setItem('roles', undefined);

    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('currentUser');
    //sessionStorage.removeItem('roles');
    
    sessionStorage.clear()
    this.subject.next(null);
    //console.log(JSON.stringify(sessionStorage))
}

}
